import Tabs from './Tabs';

document.addEventListener('DOMContentLoaded', () => {
  const tabsElement = document.querySelector('.c-tabs');
  if (!tabsElement) {
    return;
  }

  const tabs = new Tabs(tabsElement);
  tabs.mount();

  tabs.on('change', ({ button, targetContent }) => {
    console.log('Onglet actif :', button.textContent.trim());
    console.log('Contenu actif :', targetContent.id);
  });
});
